    // Generate random smooth blob shape with Catmull-Rom spline-like interpolation
    function generateSmoothBlobPath() {
      let points = 14; // Number of control points
      let radius = 30; // Blob size
      let variance = 15; // Random variance to make blob more organic

      let pathData = "";
      let controlPoints = [];

      // Create control points around a center (50, 50) with random variance
      for (let i = 0; i < points; i++) {
        let angle = (Math.PI * 2 * i) / points;
        let randomFactor = Math.random() * variance - variance / 2;
        let x = 50 + Math.cos(angle) * (radius + randomFactor); // Vary radius randomly
        let y = 50 + Math.sin(angle) * (radius + randomFactor);
        controlPoints.push({ x, y });
      }

      // Start the path at the first control point
      pathData += `M ${controlPoints[0].x} ${controlPoints[0].y} `;

      // Interpolate between the control points to create a smooth, blobby curve
      for (let i = 0; i < controlPoints.length; i++) {
        // Get the current point and the next two points to smooth the curve
        let current = controlPoints[i];
        let next = controlPoints[(i + 1) % points]; // Wrap around to the start
        let afterNext = controlPoints[(i + 2) % points];

        // Use a Catmull-Rom like curve by calculating midpoints
        let midX1 = (current.x + next.x) / 2;
        let midY1 = (current.y + next.y) / 2;
        let midX2 = (next.x + afterNext.x) / 2;
        let midY2 = (next.y + afterNext.y) / 2;

        // Draw the curve using cubic Bezier with midpoints to smooth the transitions
        pathData += `Q ${next.x} ${next.y}, ${midX2} ${midY2} `;
      }

      // Close the path
      pathData += "Z";

      return pathData;
    }

    // Apply the smooth blob path to each product card's SVG blob shape
    document.querySelectorAll(".blob-shape #blob").forEach((blob) => {
      blob.setAttribute("d", generateSmoothBlobPath());
    });